import React from 'react';
export const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/5sz3KLanLA7pcCiK4Ysk4F/IMG_0942.png';
interface LogoProps {
  className?: string;
}

/**
 * The AZ City PAC lockup. The artwork is navy and gold on a white field, so it
 * is always placed on a white plate to stay legible on the navy chrome.
 */
export function Logo({
  className = 'h-12'
}: LogoProps) {
  return <span className={`inline-flex items-center justify-center bg-white rounded px-3 py-1.5 ${className}`} data-id="element-196" data-mp="mt4671a1as6b">
      <img src={LOGO_URL} alt="AZ City PAC — Strong Cities. Stronger Arizona." className="h-full w-auto object-contain" data-id="element-197" data-mp="rs7csq5nx6ge" />
    </span>;
}